import globals from '../globals';
import { getThemeRefs } from '../../helpers/themeHelpers';
import { PolicyValidationClass } from '../../components/descope-policy-validation/PolicyValidationClass';
import { refs } from './inputWrapper';

const globalRefs = getThemeRefs(globals);
const vars = PolicyValidationClass.cssVarList;

const policyValidation = {
  [vars.fontFamily]: refs.fontFamily,
  [vars.fontSize]: refs.labelFontSize,
  [vars.textColor]: refs.labelTextColor,
  [vars.borderWidth]: refs.borderWidth,
  [vars.borderStyle]: refs.borderStyle,
  [vars.borderColor]: refs.borderColor,
  [vars.borderRadius]: globalRefs.radius.sm,
  [vars.backgroundColor]: 'none',
  [vars.padding]: '0px',
  [vars.labelMargin]: globalRefs.spacing.sm,
  [vars.itemsSpacing]: globalRefs.spacing.lg,
  [vars.itemSymbolDefault]: "'\\2022'", // "•"
  [vars.itemSymbolSuccess]: "'\\2713'", // "✓"
  [vars.itemSymbolError]: "'\\2A09'", // "⨉"
  [vars.itemSymbolSuccessColor]: globalRefs.colors.success.main,
  [vars.itemSymbolErrorColor]: globalRefs.colors.error.main,
};

export default policyValidation;
export { vars };
